export const ListingScoreRatings = {
  outstanding: 'outstanding',
  strong: 'strong',
  good: 'good',
  needsImprovement: 'needsImprovement',
  incomplete: 'incomplete',
  missingCriticalDetails: 'missingCriticalDetails',
} as const;

export const ZRAMListingScoreConstants = {
  [ListingScoreRatings.outstanding]: {
    ratingPrefix: "Your listing's quality is ",
    ratingText: 'outstanding',
    modalHeadline: 'Your listing quality is outstanding and has all the details renters need.',
  },
  [ListingScoreRatings.good]: {
    ratingPrefix: "Your listing's quality is ",
    ratingText: 'good, some details missing',
    modalHeadline:
      'Add missing details to improve completeness to help prevent negative impacts to your leads and keep your listings visible in more filtered renter searches.',
  },
  [ListingScoreRatings.needsImprovement]: {
    ratingPrefix: "Your listing's quality ",
    ratingText: 'needs improvement',
    modalHeadline:
      'Add missing details to improve completeness to help prevent negative impacts to your leads and keep your listings visible in more filtered renter searches.',
  },
  [ListingScoreRatings.missingCriticalDetails]: {
    ratingPrefix: 'Your listing is ',
    ratingText: 'missing critical details',
    modalHeadline:
      'Add missing details to improve completeness to help prevent negative impacts to your leads and keep your listings visible in more filtered renter searches.',
  },
  [ListingScoreRatings.incomplete]: {
    ratingPrefix: 'Your listing is ',
    ratingText: 'missing required details',
    modalHeadline:
      'Your listing won’t be published until required details are added. Please complete the required fields to publish your listing.',
  },
} as const;

export const ListingScoreConstants = {
  [ListingScoreRatings.outstanding]: {
    pieChartColor: '#17B036', //green400
    textColor: 'green.600',
    ratingText: 'outstanding',
    premiumAnalyticsSubText: 'You’re almost there. Improve your listing by following the personalized',
    modalHeadline: 'Your listing is almost complete, but you can add a bit more to make it stand out.',
  },
  [ListingScoreRatings.strong]: {
    pieChartColor: '#006AFF', // blue400
    textColor: 'blue.400',
    ratingText: 'strong',
    premiumAnalyticsSubText: 'Improve your listing by following the personalized',
    modalHeadline: 'Your listing is strong, but you can improve it to stand out from the crowd.',
  },
  [ListingScoreRatings.good]: {
    pieChartColor: '#F2A619', //yellow400
    textColor: 'yellow.600',
    ratingText: 'good',
    premiumAnalyticsSubText: 'Improve your listing by following the personalized',
    modalHeadline: 'Your listing is good, but you can improve it to stand out from the crowd.',
  },
  [ListingScoreRatings.needsImprovement]: {
    pieChartColor: '#E96E2F', //orange400
    textColor: 'orange.600',
    ratingText: 'needs improvement',
    premiumAnalyticsSubText: 'Improve your listing by following the personalized',
    modalHeadline: 'Your listing is missing some of the information renters may be looking for.',
  },
  // TODO: remove me once listing quality is live
  [ListingScoreRatings.missingCriticalDetails]: {
    pieChartColor: '#E96E2F', //orange400
    textColor: 'orange.600',
    ratingText: 'missing critical details',
    premiumAnalyticsSubText: 'Improve your listing by following the personalized',
    modalHeadline: 'Your listing is missing some of the information renters may be looking for.',
  },
  [ListingScoreRatings.incomplete]: {
    pieChartColor: '#E96E2F', //orange400
    textColor: 'orange.600',
    ratingText: 'incomplete',
    premiumAnalyticsSubText: '', // if property is incomplete, user will not see premium analytics
    modalHeadline: 'Your listing is missing some of the information renters may be looking for.',
  },
} as const;
